import { API_URL, API_KEY, FILTER_SERVICE } from '../configs/global';

import moment from 'moment';

export const FETCH_SERVICE = 'FETCH_SERVICE';
export const CLEAR_SERVICE = 'CLEAR_SERVICE';

export const fetchService = (route, dir, journeyId, linkDate, debug, fromStopId, toStopId, cb) => {
  linkDate = moment(linkDate, "DD-MM-YYYY").format('YYYY-MM-DD');
  let url = `${API_URL}/public-trip-by-local-departure-time-v1/${linkDate}/${route}/${dir}/${journeyId}?api_key=${API_KEY}&debug=${debug}${FILTER_SERVICE ? '&only_service_classes=' + FILTER_SERVICE : ''}`;
  if (fromStopId && toStopId)
    url += `&must_contain_stop_ids=${fromStopId},${toStopId}`;
  else if (fromStopId)
    url += `&must_contain_stop_ids=${fromStopId}`;
  else if (toStopId)
    url += `&must_contain_stop_ids=${toStopId}`;

  return (dispatch) => {
    fetch(url)
      .then((response) => response.json())
      .then((response) => {
        dispatch({
          type: FETCH_SERVICE,
          payload: response,
        });
        cb();
      })
      .catch((error) => console.log(error));
  };
};

export const clearService = (clear) => (dispatch) =>
  dispatch({
    type: CLEAR_SERVICE,
    payload: clear,
  });



// WEBPACK FOOTER //
// ./src/actions/ServiceAction.js